import { OrderSearchParams } from "@types-runway/admin";

export const orderSearchPageSize = 30;

export interface OrderSearchFilters {
  orderId: string;
  status: string;
}

// Blank filters are omitted so the API lists the most recent orders (FIND-E18); the entry is sent
// as typed so SQL metacharacters stay a literal pattern (FIND-R2).
export const buildOrderSearchParams = (
  filters: OrderSearchFilters,
  offset: number
): OrderSearchParams => {
  const orderId = filters.orderId.trim();

  return {
    ...(orderId && { orderId }),
    ...(filters.status && { status: filters.status }),
    offset,
  };
};

export const nextOffset = (offset: number) => offset + orderSearchPageSize;

export const previousOffset = (offset: number) => Math.max(0, offset - orderSearchPageSize);

// ORDERS-R19: the empty-state message names what was searched for.
export const describeEmptyOrderSearch = ({ orderId, status }: OrderSearchFilters) => {
  const term = orderId.trim();
  const termClause = `Nothing has an Order ID or Case ID starting with ${term}`;

  if (term && status) return `${termClause} and the status ${status}.`;
  if (term) return `${termClause}.`;
  if (status) return `No Orders have the status ${status}.`;
  return "No Orders exist yet.";
};
